import { createSelector } from 'reselect'

import type { ArticleSelectorParams } from './types'
import { replaceCmsTokens } from './utils'

export const articleSelector = createSelector(
    (articleSelectorParams: ArticleSelectorParams) => articleSelectorParams,
    ({ article, lookupData, shouldFormatPrice, currency, i18n }: ArticleSelectorParams): string =>
        replaceCmsTokens(article, lookupData, shouldFormatPrice, currency, i18n),
)
